import { useState } from "react";
import "./mario-coin.css";

export default function MarioCoin({ id, onEnd }: { id: number, onEnd: (id: number) => void }) {
    const [showScore, setShowScore] = useState(false);

    return (
        <div className="mario-coin-container">
            {!showScore ? (
                <img
                    src="/img/easter_eggs/mario_moeda.png"
                    className="coin"
                    onAnimationEnd={() => setShowScore(true)} // 👈 quando termina a queda
                />
            ) : (
                <img
                    src="/img/easter_eggs/mario_200.png"
                    className="score"
                    onAnimationEnd={() => onEnd(id)} // 👈 remove depois
                />
            )}
        </div>
    );
}